export default "__VITE_ASSET__jrDHkN2z__"